import React from "react";

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark tc-navbar-style1 section-padding-x">
      <div className="container-fluid content">
        <a className="navbar-brand" href="#">
          <img
            src="/home1/assets/img/logo.png"
            alt="Tetra Yapı Logo"
            className="w-200px"
          />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
            className="collapse navbar-collapse"
            style={{flexDirection: 'row-reverse'}}
            id="navbarSupportedContent">
          <ul className="navbar-nav mb-2 mb-lg-0">
            <li className="nav-item">
              <a className={`nav-link nav-link-custom active`} aria-current="page" href="/">Anasayfa</a>
            </li>
            <li className="nav-item">
              <a className={`nav-link nav-link-custom`}  href="/portfolio">Projeler</a>
            </li>
            <li className="nav-item">
              <a className={`nav-link nav-link-custom`}  href="/blog">Blog</a>

            </li>
            <li className="nav-item">
              <a className={`nav-link nav-link-custom`}  href="/contact">İletişim</a>
            </li>
          </ul>
          <div className="nav-side">
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
